import { compose, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import { getAcceptCookie } from '../../../acceptCookies';
import FBPixel from '../fbPixel';

export default compose(
  connect(
    state => ({
      acceptCookie: getAcceptCookie(state),
    })
  ),
  withPropsOnChange(
    ['acceptCookie'],
    (props) => {
      FBPixel.setGranted(props.acceptCookie);
    }
  )
);



// WEBPACK FOOTER //
// ./src/app/applicationServices/analytics/fbPixel/withConsent.js